module.exports = __webpack_public_path__ + "img/stahltreppe.89678338.webp";